var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiFileTrainedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 24,
    viewBox: "0 0 77 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161752",
    "data-name": "Group 161752",
    transform: "translate(-76 -197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161740",
    "data-name": "Group 161740",
    transform: "translate(-0.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1222",
    "data-name": "Rectangle 1222",
    transform: "translate(76.462 197)",
    fill: "#dafadd",
    stroke: "#a3d998",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 24,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 76,
    height: 23,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_83726",
    "data-name": "Path 83726",
    d: "M6.72,12H7.773V3.862h2.782V2.9H3.938v.962H6.72Zm5.005,0h1.027V8.516c0-1.287.689-2.249,1.924-2.249h.559V5.24h-.572A1.965,1.965,0,0,0,12.817,6.5h-.078V5.24H11.725Zm7.787.169a2.767,2.767,0,0,0,2.34-1.235h.078V12h.988V5.24H21.891V6.332h-.078a2.768,2.768,0,0,0-2.379-1.261,3.309,3.309,0,0,0-3.289,3.562A3.31,3.31,0,0,0,19.512,12.169Zm.065-.923A2.361,2.361,0,0,1,17.2,8.633a2.379,2.379,0,1,1,4.732,0A2.4,2.4,0,0,1,19.577,11.246Zm6.084-7.228a.731.731,0,0,0,.754-.754.748.748,0,0,0-1.5,0A.728.728,0,0,0,25.661,4.018ZM25.128,12h1.027V5.24H25.128Zm3.237,0h1.027V7.97a1.877,1.877,0,0,1,1.9-1.937,1.711,1.711,0,0,1,1.742,1.781V12h1.027V7.749a2.485,2.485,0,0,0-2.522-2.678,2.207,2.207,0,0,0-2.067,1.157h-.078V5.24H28.365Zm10.764.169a3.131,3.131,0,0,0,3.146-2.158H41.208a2.143,2.143,0,0,1-2.067,1.222,2.181,2.181,0,0,1-2.314-2.249H42.34V8.529a3.2,3.2,0,0,0-3.276-3.458A3.31,3.31,0,0,0,35.749,8.62,3.308,3.308,0,0,0,39.128,12.169Zm-2.275-4.1a2.194,2.194,0,0,1,2.21-2.067,2.085,2.085,0,0,1,2.184,2.067Zm10.153,4.1a2.767,2.767,0,0,0,2.34-1.235h.078V12h.988V2.25H49.385V6.332h-.078a2.768,2.768,0,0,0-2.379-1.261,3.309,3.309,0,0,0-3.289,3.562A3.31,3.31,0,0,0,47.007,12.169Zm.065-.923a2.361,2.361,0,0,1-2.379-2.613,2.379,2.379,0,1,1,4.732,0A2.4,2.4,0,0,1,47.071,11.246Z",
    transform: "translate(87.462 201)",
    fill: "#489a38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFileTrainedIcon);
export default __webpack_public_path__ + "static/media/ai-file-trained-icon.4c5d1846d364469192b81757ea7b4adc.svg";
export { ForwardRef as ReactComponent };